import Button from './Button'
import React from 'react'

const ExportFilter = ({onclick}) => {
  return (
    <div>
        <Button
              label="Export"
              variant="outlined"
              backgroundColor="#f15821"
              textColor="#f15821"
              sx={{
                alignSelf: "center",
                ":hover": { border: "1px solid #f15821" },
              }}
              size="small"
              onClick={onclick}
            />
    </div>
  )
}

export default ExportFilter
